import { Container, Paragraph, breakpoint, colors, spacing, typography } from 'component-library';
import styled from '@emotion/styled';

export const HeroContainer = styled.div`
  background-color: ${colors.secondary.beigeTint1};
`;

export const HeroPageContainer = styled.div`
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
  padding: ${spacing.mediumHigh} 0;

  @media (max-width: ${breakpoint.xlarge + 96}px) {
    padding: ${spacing.mediumHigh};
  }

  @media (max-width: ${breakpoint.small}px) {
    padding: ${spacing.mediumLow} ${spacing.small} ${spacing.mediumHigh} ${spacing.small};
  }
`;

export const HeroButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${spacing.small};
`;

export const Label = styled.div<{ bold?: boolean; color?: string }>`
  ${(props) => (props.bold ? typography.body.largeBold : typography.body.large)};
  margin-bottom: ${spacing.tiny};
  color: ${({ color }) => color ?? colors.primary.grey};
`;

export const SubText = styled(Label)`
  margin-bottom: ${spacing.mediumLow};
`;

export const OrderDetailsContainer = styled(Container)`
  border: 1px solid ${colors.monochrome.grey20};
  flex-direction: column;
  flex-wrap: wrap;
  gap: ${spacing.small};
`;

export const OrderDetailsDivider = styled.div`
  height: 1px;
  background-color: ${colors.monochrome.grey20};
  margin-left: -${spacing.small};
  margin-right: -${spacing.small};
`;

export const OrderDetailsRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0 ${spacing.xsmall};
  max-width: 100%;

  @media (max-width: ${breakpoint.large}px) {
    flex-direction: column;
    gap: ${spacing.small} 0;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.xsmall};
`;

export const OrderDetailsColumn = styled.div`
  display: flex;
  min-width: 240px;

  flex-direction: column;
  flex: 1;
`;

export const OrderDetailsValue = styled(Paragraph)`
  margin-bottom: ${spacing.tiny};
`;
